import { faClock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HTMLReactParser from 'html-react-parser';
import { useCallback, useContext, useEffect, useState } from 'react';
import { QuizContext } from 'src/views/Quiz/Quiz.context';
import QuizInfoTemplate from 'src/views/Quiz/QuizInfoTemplate/QuizInfoTemplate';
import styles from './quiz-onboarding.module.scss';
import { Vertical } from 'src/constants/Verticals';
import { Badge, useTheme } from '@get-mosh/msh-shared';
import Image from 'next/image';
import Disclaimer from 'src/components/Disclaimer';

const QuizOnboarding = () => {
    const { currentQuestion, handleSubmitAnswer } = useContext(QuizContext);
    const {
        questionText,
        questionExplanation,
        questionImage,
        estimateTimeText,
    } = currentQuestion || {};
    const [continueDisabled, setContinueDisabled] = useState(false);

    const handleSubmit = useCallback(() => {
        if (currentQuestion.questionId && !continueDisabled) {
            setContinueDisabled(true);
            handleSubmitAnswer({
                questionId: currentQuestion.questionId,
                questionText: currentQuestion.questionText,
            });
        }
    }, [currentQuestion, continueDisabled, handleSubmitAnswer]);

    const { quizType } = useContext(QuizContext);
    const { isMosh } = useTheme();

    useEffect(() => {
        const handleKeyPress = (e: KeyboardEvent) => {
            if (e.key === 'Enter') handleSubmit();
        };
        window.addEventListener('keydown', handleKeyPress, false);

        return () =>
            window.removeEventListener('keydown', handleKeyPress, false);
    }, [handleSubmit]);

    return (
        <QuizInfoTemplate contentClassName="align-top-mobile">
            <div className={styles['quiz--onboarding']}>
                {questionImage ? (
                    <div className={styles['icon-wrapper']}>
                        <Image
                            src={questionImage}
                            className={styles['icon']}
                            alt={questionText}
                            unoptimized
                            width={80}
                            height={65}
                        />
                    </div>
                ) : null}
                <span className={styles['section-wrapper']}>
                    <h3 className={styles['title']}>
                        {HTMLReactParser(questionText)}
                    </h3>
                    <span className={styles['spacer']} />
                    <p className={styles['subtitle']}>{questionExplanation}</p>
                </span>
                <span className={styles['section-wrapper--tight']}>
                    <Badge variant="fill-dark">
                        <FontAwesomeIcon icon={faClock} /> {estimateTimeText}
                    </Badge>
                    <Disclaimer
                        darkMode={isMosh}
                        title="Quiz Onboarding"
                        vertical={quizType as Vertical}
                    />
                </span>
            </div>
        </QuizInfoTemplate>
    );
};

export default QuizOnboarding;
